import React, { useRef, useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { AcceptButton, CancelButton } from '../../components/Button';
import { no_image } from 'src/common/images';
import { COLOR } from 'src/common/constant';
import { Global } from 'src/GlobalClass';
import { uploadImageNoResize, AWS_IMAGE_BASE_URL, AWS_IMAGE_FOLDERS } from 'src/api/axios';
// import DatePicker from 'react-datepicker';
// import moment from 'moment';
import schoolRequestStore from '../stores/SchoolRequestStore';

const SchoolRequestTypes = [
  { id: 1, name: 'Cấp 1', type: 'C1' },
  { id: 2, name: 'Cấp 2', type: 'C2' },
  { id: 3, name: 'Cấp 3', type: 'C3' },
  { id: 4, name: 'Cao đẳng', type: 'CĐ' },
  { id: 5, name: 'Đại học', type: 'ĐH' },
  { id: 6, name: 'Viện nghiên cứu', type: 'VNC' },
  { id: 7, name: 'Khác', type: 'Other' },
]

const EditSchoolRequestModal = ({
  isShow,
  schoolRequest,
}) => {
  const inputFileRef = useRef(null);
  const [schoolRequestType, setSchoolRequestType] = useState(schoolRequest ? schoolRequest.type : undefined);
  const [disabledSubmit, setDisabledSubmit] = useState(true);
  const [imageUrl, setImageUrl] = useState(schoolRequest ? schoolRequest.logo : undefined);
  const [schoolRequestName, setSchoolRequestName] = useState(schoolRequest ? schoolRequest.name : undefined);
  const [schoolRequestDistrict, setSchoolRequestDistrict] = useState(schoolRequest ? schoolRequest.district : undefined);
  const [schoolRequestProvince, setSchoolRequestProvince] = useState(schoolRequest ? schoolRequest.province : undefined);
  const [schoolRequestAddress, setSchoolRequestAddress] = useState(schoolRequest ? schoolRequest.address : undefined);
  const [schoolRequestDesc, setSchoolRequestDesc] = useState(schoolRequest ? schoolRequest.description : undefined);
  const [schoolRequestShortName, setSchoolRequestShortName] = useState(schoolRequest ? schoolRequest.shortName : undefined);
  const [schoolRequestEnName, setSchoolRequestEnName] = useState(schoolRequest ? schoolRequest.enName : undefined);
  const [schoolRequestLat, setSchoolRequestLat] = useState(schoolRequest ? schoolRequest.lat : undefined);
  const [schoolRequestLng, setSchoolRequestLng] = useState(schoolRequest ? schoolRequest.lng : undefined);
  const [errLinkMessage, setErrLinkMessage] = useState();

  useEffect(() => {
    if (schoolRequest) {
      setSchoolRequestType(schoolRequest.type);
      setImageUrl(schoolRequest.logo);
      setSchoolRequestName(schoolRequest.name);
      setSchoolRequestDistrict(schoolRequest.district);
      setSchoolRequestProvince(schoolRequest.province);
      setSchoolRequestAddress(schoolRequest.address);
      setSchoolRequestDesc(schoolRequest.description);
      setSchoolRequestShortName(schoolRequest.shortName);
      setSchoolRequestEnName(schoolRequest.enName);
      setSchoolRequestLat(schoolRequest.lat);
      setSchoolRequestLng(schoolRequest.lng);
      return () => { resetState() };
    }
  }, [schoolRequest])

  useEffect(() => {
    if (!!imageUrl && !!schoolRequestName && !!schoolRequestDistrict && !!schoolRequestProvince && !!schoolRequestAddress && !!schoolRequestType) {
      setDisabledSubmit(false);
      return;
    }
    if (!disabledSubmit) setDisabledSubmit(true);
  }, [imageUrl, schoolRequestName, schoolRequestDistrict, schoolRequestProvince, schoolRequestAddress, schoolRequestType])

  const onPickImage = () => {
    if (inputFileRef.current) inputFileRef.current.click();
  }

  const onPickFileSuccess = async (e) => {
    let file = e.target.files[0];
    if (!file) return;
    if (!file.type.includes('image')) return Global.error({ message: 'Vui lòng chọn file định dạng ảnh !' });
    const formData = new FormData();
    formData.append("file", file);
    uploadImage(formData);
  }

  const uploadImage = async (form) => {
    try {
      const result = await uploadImageNoResize(form);
      if (result.data) {
        setImageUrl(result.data.imageName ? AWS_IMAGE_BASE_URL + AWS_IMAGE_FOLDERS.md + '/' + result.data.imageName : result.data.uploadedUrl);
      }
    }
    catch (err) {
      console.log(err)
    }
  }

  const validURL = (str) => {
    var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return !!pattern.test(str);
  }

  const handleSubmit = async () => {
    const { approveSchoolRequest, createSchoolRequest } = schoolRequestStore;
    if (errLinkMessage) setErrLinkMessage(undefined);
    try {
      if (!!schoolRequest && !!schoolRequest.id) {
        await approveSchoolRequest(
          schoolRequest.id,
          {
            id: schoolRequest.id,
            name: schoolRequestName,
            logo: imageUrl,
            name: schoolRequestName,
            district: schoolRequestDistrict,
            province: schoolRequestProvince,
            address: schoolRequestAddress,
            description: schoolRequestDesc,
            shortName: schoolRequestShortName,
            enName: schoolRequestEnName,
            lat: schoolRequestLat,
            lng: schoolRequestLng,
            type: schoolRequestType
          })
      }
      else {
        await createSchoolRequest({
          name: schoolRequestName,
          logo: imageUrl,
          name: schoolRequestName,
          district: schoolRequestDistrict,
          province: schoolRequestProvince,
          address: schoolRequestAddress,
          description: schoolRequestDesc,
          shortName: schoolRequestShortName,
          enName: schoolRequestEnName,
          lat: schoolRequestLat,
          lng: schoolRequestLng,
          type: schoolRequestType
        })
      }
    }
    catch (err) {
      Global.error({ messgae: 'Có lỗi xảy ra. Vui lòng thử lại' })
    }
  }

  const handleCancel = () => {
    onHideModal();
  }

  const resetState = () => {
    setSchoolRequestType(undefined)
    setImageUrl(undefined)
  }

  const onHideModal = () => {
    const { getSchoolRequestList, clearCurrentSchoolRequest, setShowModal } = schoolRequestStore;
    setShowModal(false);
    getSchoolRequestList();
    clearCurrentSchoolRequest();
  }

  return <Modal
    show={isShow}
    size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered
    scrollable
    animation
    onHide={onHideModal}
  >
    <Modal.Header closeButton >
      <Modal.Title style={{ fontWeight: 'bold' }} id="contained-modal-title-vcenter">
        Chỉnh sửa thông tin trường
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16 }}>
        <img alt='' style={{ height: 300, maxWidth: '30vw', objectFit: 'contain', marginBottom: 6, marginTop: 16, border: `solid 0.5px ${COLOR.tertiary_light}` }}
          src={imageUrl || no_image} />
        <div className='td-actions text-center' style={{ marginLeft: 6 }}>
          <button onClick={onPickImage} type="button" rel="tooltip" className="btn btn-warning btn-simple">
            <i className="material-icons">edit</i>
          </button>
        </div>
      </div>
      <br />
      <div style={{ height: 16 }} />

      <div style={{ marginTop: 16, marginBottom: 16 }} >
        <label style={{ marginRight: 16, width: '15%' }} >Tên trường(*)</label>
        <input type='text' style={{ width: '40%', padding: 5 }} onChange={e => setSchoolRequestName(e.target.value)} value={schoolRequestName} />
      </div>

      <div style={{ marginTop: 16, marginBottom: 16 }} >
        <label style={{ marginRight: 16, width: '15%' }} >Quận/Huyện(*)</label>
        <input type='text' style={{ width: '40%', padding: 5 }} onChange={e => setSchoolRequestDistrict(e.target.value)} value={schoolRequestDistrict} />
      </div>

      <div style={{ marginTop: 16, marginBottom: 16 }} >
        <label style={{ marginRight: 16, width: '15%' }} >TP/Tỉnh(*)</label>
        <input type='text' style={{ width: '40%', padding: 5 }} onChange={e => setSchoolRequestProvince(e.target.value)} value={schoolRequestProvince} />
      </div>

      <div style={{ marginTop: 16, marginBottom: 16 }} >
        <label style={{ marginRight: 16, width: '15%' }} >Địa chỉ(*)</label>
        <input type='text' style={{ width: '40%', padding: 5 }} onChange={e => setSchoolRequestAddress(e.target.value)} value={schoolRequestAddress} />
      </div>

      <div style={{ marginTop: 16, marginBottom: 16 }} >
        <label style={{ marginRight: 16, width: '15%' }} >Mô tả</label>
        <input type='text' style={{ width: '40%', padding: 5 }} onChange={e => setSchoolRequestDesc(e.target.value)} value={schoolRequestDesc} />
      </div>

      <div style={{ marginTop: 16, marginBottom: 16 }} >
        <label style={{ marginRight: 16, width: '15%' }} >Tên viết tắt</label>
        <input type='text' style={{ width: '40%', padding: 5 }} onChange={e => setSchoolRequestShortName(e.target.value)} value={schoolRequestShortName} />
      </div>

      <div style={{ marginTop: 16, marginBottom: 16 }} >
        <label style={{ marginRight: 16, width: '15%' }} >Tên tiếng Anh</label>
        <input type='text' style={{ width: '40%', padding: 5 }} onChange={e => setSchoolRequestEnName(e.target.value)} value={schoolRequestEnName} />
      </div>

      <div style={{ marginTop: 16, marginBottom: 16 }} >
        <label style={{ marginRight: 16, width: '15%' }} >Latitude</label>
        <input type='text' style={{ width: '40%', padding: 5 }} onChange={e => setSchoolRequestLat(e.target.value)} value={schoolRequestLat} />
      </div>

      <div style={{ marginTop: 16, marginBottom: 16 }} >
        <label style={{ marginRight: 16, width: '15%' }} >Longitude</label>
        <input type='text' style={{ width: '40%', padding: 5 }} onChange={e => setSchoolRequestLng(e.target.value)} value={schoolRequestLng} />
      </div>

      <label
        style={{ marginRight: 16, width: '15%' }}
      >Chọn loại trường(*):</label>
      <select name="event" value={schoolRequestType}
        onChange={e => {
          setSchoolRequestType(e.target.value)
        }}
        style={{ padding: 5, width: '40%' }}
      >
        <option disabled value selected > -- Chọn một loại -- </option>
        {
          SchoolRequestTypes.map(e => <option value={e.type} key={e.type} >{e.name}</option>)
        }
      </select>

      <input hidden accept="image/*" onChange={onPickFileSuccess} ref={inputFileRef} type='file' id='img-banner' />
    </Modal.Body>
    <Modal.Footer>
      <CancelButton onClick={handleCancel} title='Huỷ' />
      <AcceptButton disabled={disabledSubmit} onClick={handleSubmit} title={!!schoolRequest && !!schoolRequest.id ? 'Tạo trường' : 'Tạo yêu cầu mới'} />
    </Modal.Footer>
  </Modal>
}

export default EditSchoolRequestModal;